// GLOBAL FUNCTIONS (NOW ALWAYS LOADED)
window.openRecommendDrawer = function () {
  const drawer = document.getElementById("recommendDrawer");
  if (drawer) drawer.classList.add("active");
};

window.closeRecommendDrawer = function () {
  const drawer = document.getElementById("recommendDrawer");
  if (drawer) drawer.classList.remove("active");
};

window.loadRecentlyViewed = async function () {
  const handles = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
  if (!handles.length) return;

  const wrapper = document.getElementById("recentlyViewedWrapper");
  if (wrapper) wrapper.classList.remove("hidden");

  const container = document.getElementById("recentlyViewedProducts");
  if (!container) return;

  for (const h of handles) {
    try {
      const res = await fetch(`/products/${h}.js`);
      const p = await res.json();
      container.innerHTML += `
        <a href="${p.url}" class="drawer-item">
          <img src="${p.images[0]}" />
          <p class="drawer-item-title">${p.title}</p>
        </a>
      `;
    } catch (e) {}
  }
};

// AUTO SAVE RECENT PRODUCT
document.addEventListener("DOMContentLoaded", () => {
  const handle = window.RecommendDrawerProductHandle || "";

  if (handle) {
    let viewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    viewed = viewed.filter((h) => h !== handle);
    viewed.unshift(handle);
    localStorage.setItem("recentlyViewed", JSON.stringify(viewed.slice(0, 6)));
  }

  const ref = document.referrer || "";
  const autoOpen = window.RecommendDrawerAutoOpen;

 if (autoOpen && ref.includes("/products/") && window.location.pathname === "/") {
  setTimeout(() => {
    loadRecentlyViewed();
    openRecommendDrawer();
  }, 3000); // 3 seconds delay
 }
});
